import { createSvgIcon } from 'src/components/Icons/utils';

export default createSvgIcon(
  <path d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z" />,
  'H1',
  '0 0 24 24'
);
